import React from "react";
import { Button, useTitle } from "modules/common";
import { getEPoljoprivredaUrl } from "helpers/EnvironmentHelper";
import { entityChangeCache } from "modules/auth";
import { changeNiasEntityRequestParameters, changeNiasEntityRequestProperties } from "services";

export const Unauthorized: React.FC = () => {
    useTitle("Neovlašteno - eSavjetnik");

    const url = new URL(`${getEPoljoprivredaUrl()}aplikacije`);
    const entityChange = entityChangeCache().get();
    changeNiasEntityRequestProperties.forEach(property => {
        const parameter = changeNiasEntityRequestParameters[property.value];
        url.searchParams.append(parameter, entityChange?.request?.[property.value] ?? "");
    });

    return (
        <div className="unauthorized">
            <h1 className="unauthorized-heading mt-72">Neovlašteno</h1>
            <p className="unauthorized-description">Nemate ovlasti pristupa traženom sadržaju.</p>

            <a className="unauthorized-link" href={url.toString()} rel="noreferrer">
                <Button size="medium" variant="primary-ghost">
                    ePoljoprivreda
                </Button>
            </a>
        </div>
    );
};
